
import {FolderableInterface} from 'storyboard-renderer';
import {Folder} from 'storyboard-renderer';
export class FolderContainer {

  rootFolder: Folder = new Folder(0, 'root');
  folders: Folder[] = [];
}



// WEBPACK FOOTER //
// ./src/app/storyboard/shared/FolderContainer.ts